import React from "react";
import FieldNotesSidebarWrap from "./FieldNotesSidebarWrap";

function AllFieldNotes() {
  return <FieldNotesSidebarWrap />;
}

export default AllFieldNotes;
